import { render } from "./priceTableComponent.vue?vue&type=template&id=971f4424&scoped=true"
import script from "./priceTableComponent.vue?vue&type=script&lang=js"
export * from "./priceTableComponent.vue?vue&type=script&lang=js"

import "./priceTableComponent.vue?vue&type=style&index=0&id=971f4424&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971f4424"]])

export default __exports__